// extracted by mini-css-extract-plugin
module.exports = {"itemsContainer":"filter-container-module__itemsContainer___HmV6F","mobileContainer":"filter-container-module__mobileContainer___2pMSy"};